import Document from "../general/document";

export interface VehicleData {
  description: string;
  projectId: string;
  customProperties?: {
    "PROJECT.KENTEKEN"?: string;
  };
}

class Vehicle extends Document<VehicleData> {
  get title() {
    return this.data.description;
  }

  get fullTitle() {
    return `${this.data.projectId} ${this.data.description}`;
  }

  get projectId() {
    return this.data.projectId;
  }
}

export default Vehicle;
